import "./App.css";
import NotFound from "./pages/errors/404NotFound";
import Login from "./pages/Login";
import TransaksiKeuangan from "./pages/transaksiKeuangan/TransaksiKeuangan";
import { Routes, Route } from "react-router-dom";

function App() {
  // Clear local storage if token expired
  const today = new Date();
  const tokenExpired = localStorage.getItem("tokenExpired");

  if (tokenExpired) {
    if (new Date(tokenExpired) < new Date(today)) {
      localStorage.clear();
      localStorage.setItem("isExpired", true);
    }
  }

  return (
    <div className="app">
      <Routes>
        <Route exact path="/" element={<Login />} />
        <Route
          exact
          path="/transaksi-keuangan"
          element={<TransaksiKeuangan />}
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;
